import { render, staticRenderFns } from "./HealthCheck45PsaThyroidLiver.vue?vue&type=template&id=0478bea4&scoped=true&"
import script from "./HealthCheck45PsaThyroidLiver.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45PsaThyroidLiver.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45PsaThyroidLiver.vue?vue&type=style&index=0&id=0478bea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478bea4",
  null
  
)

export default component.exports